import React, { ReactNode } from 'react';
import styles from '../../styles.module.css';
import { Blog, shop } from '@/commonTypes';
import { blogBg } from '@/functions/formats';
import MainIcons from '@/icons/main';
import AppImage from '@/components/common/AppImage';

export default function BlogCover({
  featured = false,
  item,
  index = 0,
  className = '',
  children,
  size = 'thumbnail',
}: {
  item?: Blog | shop;
  featured?: boolean;
  index?: number;
  className?: string;
  children?: ReactNode;
  size?: 'thumbnail' | 'full';
}) {
  const blogItem = item as Blog | undefined;
  const image = size === 'full' ? (blogItem?.cover ?? blogItem?.image) : blogItem?.image;

  if (image?.name) {
    return (
      <div className={`${styles.cover} ${className}`}>
        <AppImage
          src={image.name}
          alt={blogItem?.title || 'کارا'}
          className={styles.coverImage}
          containerclassName={styles.coverImageContainer}
        />
        {featured && (
          <span className={styles.featTag}>
            <MainIcons.fireIcon fill="var(--accent)" />
            داغ
          </span>
        )}
        {children}
      </div>
    );
  }

  return (
    <div
      className={`${styles.cover} ${className}`}
      style={{ background: index ? blogBg(index) : blogBg(0) }}
    >
      <div className={styles.coverStripes} />
      <span className={styles.coverHint}>{item?.imgHint}</span>
      {item?.category?.title && <span className={styles.cat}>{item?.category?.title}</span>}
      {featured && (
        <span className={styles.featTag}>
          <MainIcons.fireIcon fill="var(--accent)" />
          داغ
        </span>
      )}
      {children}
    </div>
  );
}
